import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { App } from './App';
import { store } from './business/root-store';
import './index.css';
import './style.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root container #root missing in index.html');
const root = createRoot(container);

root.render(
	<React.StrictMode>
		<Provider store={store}>
			<App />
			<ToastContainer
				autoClose={4000}
				newestOnTop={false}
				position="top-right"
				closeOnClick
			/>
		</Provider>
	</React.StrictMode>
);
